import { FC, ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { usePrivacyPolicyDocument } from 'shared/hooks'
import { Button } from 'shared/ui/button'
import { CheckBox } from 'shared/ui/check-box'

import s from './styles.module.scss'

interface Props {
  isConfirmed: boolean
  onConfirm?: (isConfirmed?: boolean) => void
}

interface PropsConfirm {
  isChecked?: boolean
  text?: ReactNode
  onClick?: (value?: boolean) => void
}

const ConfirmBlock: FC<PropsConfirm> = ({ isChecked, text, onClick }) => {
  return (
    <div className={s.checkBoxBlock}>
      <div className={s.checkBox}>
        <CheckBox
          onClick={onClick}
          isChecked={isChecked}
        />
      </div>

      <div className={s.textBlock}>{text}</div>
    </div>
  )
}

export const MplusConfirm: FC<Props> = ({ onConfirm, isConfirmed }) => {
  const { t } = useTranslation()
  const { openPrivacyPolicy } = usePrivacyPolicyDocument()

  const onShowPublicOffer = () => {
    void openPrivacyPolicy('mplus_public_offer')
  }

  return (
    <div className={s.confirms}>
      <ConfirmBlock
        onClick={onConfirm}
        isChecked={isConfirmed}
        text={
          <p className={clsx(s.text, 'regular-12')}>
            {t('mplus.confirm_text_first')}

            <span
              className={s.blueText}
              onClick={onShowPublicOffer}
            >
              {t('mplus.confirm_text_second')}
            </span>

            {t('mplus.confirm_text_third')}
          </p>
        }
      />
    </div>
  )
}

export const MplusConfirmForNotAvailable = () => {
  const { t } = useTranslation()

  return (
    <div className={s.disabledButton}>
      <Button disabled>
        <span className={'bold-16'}>{t('mplus.arrange')}</span>
      </Button>
    </div>
  )
}
